import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('BeslutningRessurs');

export class BeslutningRessurs extends BasisRessurs<l.BeslutningModell> {

    static regNavn = "beslutninger";

    static forInjisering() {
        return [
            "$resource",
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            BeslutningRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService, ressursFeilhåndtering: RessursFeilhåndtering, gettextCatalog: gettextCatalog) {
        super("beslutning",
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                finnAlle: {method: 'POST', url: '/api/beslutning/finnAlle', params: {}}, //@todo burde vært GET
                finn: {method: 'POST', url: '/api/beslutning/finn', params: {id: ""}, isArray: true},
                beslutningAggregater: {method: 'POST', url: '/api/beslutning/beslutningAggregater', params: {}},

                opprettOppgave: {method: 'PUT', url: '/api/beslutning/:beslutningId/opprettOppgave', params: {id: "", beslutningId: '@beslutningId'}},
                slettOppgave: {method: 'DELETE', url: '/api/beslutning/:beslutningId/slettOppgave/:oppgaveId', params: {id: "", beslutningId: '@beslutningId', oppgaveId: '@oppgaveId'}},
            });
    }

    //offentlige metoder
    
    //overstyrt her for å få typedeklarasjonen
    oppdater(spesifikasjon: l.OppdaterBeslutningOgOppgaverSpesifikasjon): l.BeslutningModell {
        return super.oppdater(spesifikasjon);
    }

    /** @deprecated fjernes når mobil app benytter finn() */
    finnAlle(sisteInnlastedeMøteDato: Date) {
        return this.ressurs['finnAlle']({fraDato: sisteInnlastedeMøteDato}, _.noop, this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke hente beslutninger')))
    }

    finn(spesifikasjon: l.FinnBeslutningerSpesifikasjon): l.BeslutningMedMøteModell[] {
        debug("finn", spesifikasjon)
        return this.ressurs['finn'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke hente beslutninger')));
    }

    beslutningAggregater(spesifikasjon: l.FinnBeslutningerSpesifikasjon): l.BeslutningAggreatModell {
        debug("beslutningAggregater", spesifikasjon);
        return this.ressurs['beslutningAggregater'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste beslutning aggregater")));
    }

    opprettOppgave(beslutningId, spesifikasjon): l.OppgaveModell {
        debug("opprettOppgave", beslutningId, spesifikasjon)
        return this.ressurs["opprettOppgave"](
            _.defaults({beslutningId: beslutningId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke opprette oppgave under sak'))
        );
    }

    slettOppgave(beslutningId, oppgaveId, vedOk: Function = _.noop): l.OkRespons {
        debug("slettOppgave", beslutningId, oppgaveId)
        return this.ressurs["slettOppgave"](
            {beslutningId: beslutningId, oppgaveId: oppgaveId},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke slette oppgave under beslutning"))
        );
    }
}


